import { IAppState } from '../state/app.state';
import { createSelector } from '@ngrx/store';
import { IMessageState } from '../state/message.state';

const messageState = (state: IAppState) => state.message;

export const selectMessage = createSelector(
    messageState,
    (state: IMessageState) => state.message
);
